import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
type SliderItemProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly isDisabled?: boolean;
};
export function SliderItem(t0) {
  const $ = _c(6);
  const {
    children,
    className,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = clsx("shrink-0 grow basis-full", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isDisabled ? true : undefined;
  let t4;
  if ($[2] !== children || $[3] !== t2 || $[4] !== t3) {
    t4 = <li className={t2} inert={t3}>{children}</li>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}